import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { Col, Row, Button, Input } from 'reactstrap';
import { addTeamUnavailability, getTeams, getTeamUnavailability } from 'store/actions';
import CreateTeamUnAvailability from './CreateTeamUnAvailability';
import TeamUnAvailabilityTable from './TeamUnAvailabilityTable';

const TeamUnAvailabilityList = ({teamId}) => {
    const [selectedTeam, setSelectedTeam] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [isOpen, setIsOpen] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const teams = useSelector((state) => state.Team.teams);
    const teamUnavailabilities = useSelector((state) => state.TeamUnAvailability.teamUnavailability);
    const loading = useSelector((state) => state.TeamUnAvailability.loading);
    const error = useSelector((state) => state.TeamUnAvailability.error);

    const permissions2 = JSON.parse(localStorage?.getItem('permissions'));

    // Fetch teams and unavailabilities when component mounts
    useEffect(() => {
        if(loading)return;
        dispatch(getTeamUnavailability(teamId));
    }, [dispatch]);

    // Update filtered data when `selectedTeam` or `teamUnavailabilities` changes
    useEffect(() => {
        if (selectedTeam) {
            setFilteredData(
                teamUnavailabilities?.Data?.filter(
                    (item) => item.teamId === selectedTeam.value
                ) || []
            );
        } else {
            setFilteredData(teamUnavailabilities?.Data || []);
        }
    }, [selectedTeam, teamUnavailabilities]);

    const handleSelectTeam = (selectedOption) => {
        setSelectedTeam(selectedOption);
    };

    const handleSubmit = (data) => {
        dispatch(addTeamUnavailability(data));
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <>
            <CreateTeamUnAvailability
                visible={isOpen}
                onSubmit={handleSubmit}
                handleClose={handleClose}
                selectedTeam={selectedTeam}
                teamId={teamId}
            />
            <div className=" container-fluid">
                <div className="d-flex justify-content-end align-items-center mx-3">
                    {/* <Breadcrumb title="Team UnAvailabilities" breadcrumbItems={[{ title: "Dashboard", link: `/dashboard` }, { title: "Team UnAvailabilities", link: '#' }]} /> */}
                    {permissions2?.map(item=>item?.permissionName)?.includes("Add Team Unavailability") && <Button
                        className="bg-primary text-white d-flex justify-content-center gap-1 align-items-center"
                        onClick={() => setIsOpen(true)}
                    >
                        <i className="ti-plus"></i> Add New
                    </Button>}
                </div>
                <Row className="ms-1">
                    <Col lg={6}>
                        <Row className="mb-3">
                            <Col xs={6}>
                                {/* <Select
                                    value={selectedTeam}
                                    isClearable={true}
                                    onChange={handleSelectTeam}
                                    options={teams?.Data?.map((team) => ({
                                        label: team.teamName,
                                        value: team.teamId,
                                    }))}
                                    classNamePrefix="select2-selection"
                                    placeholder="Select Team"
                                /> */}
                            </Col>
                        </Row>
                    </Col>
                    <Col className="mb-3" lg={6}>

                    </Col>
                </Row>
                <TeamUnAvailabilityTable
                    List={filteredData}
                    loading={loading}
                    error={error}
                    teamId={teamId}
                />
            </div>
        </>
    );
};

export default TeamUnAvailabilityList;
